import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import ManageMailInboxAddresseesTable from "../../../containers/ManageMailInboxAddresseesTable/ManageMailInboxAddresseesTable";

const ManageMailInboxAddressees = () => {
  const tRP = "components.mail_inbox_addressees_table";
  const { t } = useTranslation();
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    <>
      {portalHeader &&
        ReactDOM.createPortal(
          <>
            <Typography
              variant="h3"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {`${t(`${tRP}.table_title`)}`}
            </Typography>
          </>,
          portalHeader
        )}
      <ManageMailInboxAddresseesTable />
    </>
  );
};

export default ManageMailInboxAddressees;
